import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

const isAccessAllowed = async (
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
    authData: AuthGuardData
): Promise<boolean | UrlTree> => {
    const { authenticated, grantedRoles } = authData;
    const requiredRoles = route.data['roles'] as string[] | undefined;

    const router = inject(Router);

    // Sem papéis definidos → nega o acesso
    if (!requiredRoles || requiredRoles.length === 0) {
        return router.parseUrl('/auth/access-denied');
    }

    // Valida cada recurso.papel; o prefixo reservado 'realm.' consulta as
    // realm roles do token (mesma convenção do backend)
    const hasRequiredRole = requiredRoles.some(required => {
        const [resource, role] = required.split('.');
        if (resource === 'realm') {
            return grantedRoles.realmRoles.includes(role);
        }
        const rolesForResource = grantedRoles.resourceRoles[resource];
        return rolesForResource?.includes(role);
    });

    return authenticated && hasRequiredRole
        ? true
        : router.parseUrl('/auth/access-denied');
};

export const canActivateAuthRole = createAuthGuard(isAccessAllowed);
